import { render } from "./EmpleadoArchivoTipoForm.vue?vue&type=template&id=5a2832ae&scoped=true"
import script from "./EmpleadoArchivoTipoForm.vue?vue&type=script&lang=js"
export * from "./EmpleadoArchivoTipoForm.vue?vue&type=script&lang=js"

import "./EmpleadoArchivoTipoForm.vue?vue&type=style&index=0&id=5a2832ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a2832ae"]])

export default __exports__